import { render, staticRenderFns } from "./InsurerLoadingValues.vue?vue&type=template&id=0dea72d7"
import script from "./InsurerLoadingValues.vue?vue&type=script&lang=js"
export * from "./InsurerLoadingValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dea72d7')) {
      api.createRecord('0dea72d7', component.options)
    } else {
      api.reload('0dea72d7', component.options)
    }
    module.hot.accept("./InsurerLoadingValues.vue?vue&type=template&id=0dea72d7", function () {
      api.rerender('0dea72d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerLoadingValues.vue"
export default component.exports